const EnumTicketStatus = {
  AWAITING_RESPONSE: "AWAITING_RESPONSE",
  OPEN: "OPEN",
  CLOSED: "CLOSED",
};

export default EnumTicketStatus;
